'use strict';

require('babel-polyfill');

module.exports = {
    api_version: '2.14.0',
    client_id: 'IBONUS_ANDROID',
    client_secret: '4sp4OOL6JMmzDbs9Dr8SWMBRLdZeKWfq'
    // localhost: ''
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.ibonus.js
// module id = 761
// module chunks = 0